import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ConnectionGuard from './guards/connectionguard';
import ConnectionGuard2 from './guards/connectionguard2';
import { AutoRefreshConnexion } from './utils/refreshConnexion';
import Register from './pages/auth/register';
import Login from './pages/auth/login';
import Dashboard from './pages/dashboard';
import Users from './pages/users';
import Payment from './pages/payment';
import ForgotPassword from './pages/auth/forgotPassword';
import jwt_decode from 'jwt-decode';
import dayjs from 'dayjs';
import { allService } from './services';
import RouteChangeTracker from './routeTracker';
import Terms from './pages/terms';

function Routes() {
  const result = useSelector((state) => state.user);
  const isAuthenticated = useSelector((state) => state.connection);
  const userRole = !allService.empty(result) ? result.role : null;
  const userToken = useSelector((state) => state.token);

  if (!allService.empty(userToken)) {
    const user = jwt_decode(userToken);
    const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;
    if (isExpired) {
      AutoRefreshConnexion();
    }
  }

  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Users} />
        <Route exact path="/privacy-policy" component={Terms} />
        <Route exact path="/collect/:token" component={Payment} />
        {
          <ConnectionGuard2
            exact
            path="/dashboard"
            component={Dashboard}
            appProps={{ isAuthenticated, userRole, defineRole: 'ADMIN' }}
          />
        }
        <ConnectionGuard
          exact
          path="/login"
          component={Login}
          appProps={{ isAuthenticated, userRole }}
        />
        <ConnectionGuard
          exact
          path="/register"
          component={Register}
          appProps={{ isAuthenticated, userRole }}
        />
        <ConnectionGuard
          exact
          path="/forgot-password"
          component={ForgotPassword}
          appProps={{ isAuthenticated, userRole }}
        />
        <Route exact path="/register" component={Register} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
      </Switch>
      <RouteChangeTracker />
    </Router>
  );
}

export default Routes;
